import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES } from 'shared/constants';

const propsSchema = [
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  }
];

const defaultProps = {
  color_theme: 'LIGHT'
};

export default {
  title: 'FutureSight Separator',
  id: 'FutureSightSeparator',
  propsSchema,
  defaultProps
};
